import React from 'react'
import "./about.css"
import ME from "../../assets/aboutpic.webp"
import {BsAwardFill} from "react-icons/bs"
import {FaUsers} from "react-icons/fa"
import {GiEasel} from "react-icons/gi"

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about_container">
        <div className="about_me">
          <div className="about_me-image">
              <img src={ME} alt="picture of myself" />
          </div>
        </div>
        <div className="about_content">
          <div className="about_cards">
            <article className="about_card">
              <BsAwardFill className='about_icon'/>
              <h5>Experience</h5>
              <small>5+ Years Working</small>
            </article>
            <article className="about_card">
              <FaUsers className='about_icon'/>
              <h5>Clients</h5>
              <small>20+ clients</small>
            </article>
            <article className="about_card">
              <GiEasel className='about_icon'/>
              <h5>Projects</h5>
              <small>6 completed projects</small>
            </article>
          </div>
          <p>I'm a self-taught front-end web developer with 5+ years of experience. I offer strong communication skills, and a never satisfied mindset. I'm constantly looking for ways to improve, and hope that my next experiences continue to push me towards my goal of being the best web-developer I can be.</p>
          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About